import axios from 'axios'

export default function superFetchObject(params){
  return axios.post(
      params.url,
      params.data,
      {
        headers:{
          'content-type': 'multipart/form-data'
        }
      }
  ).then(response =>{
      return({payload : response.data})
  }).catch(err => {
      return({ err })
  });
};



// WEBPACK FOOTER //
// ./src/modules/superFetchObject.js